import { useCallback, useEffect, useRef, useState } from 'react';
import { useScreenLayout } from './ScreenLayoutProvider';
import { SIDEBAR_MAX_WIDTH, SIDEBAR_MIN_WIDTH } from './useScreenSidebar';
import useMobile from '../hooks/useMobile';
export const useDraggableWidth = () => {
    const { sidebar } = useScreenLayout();
    const { setSidebarWidthVariable } = sidebar;
    const [dragging, setDragging] = useState(false);
    const frameID = useRef(0);
    const isMobile = useMobile();
    const onDraggableMouseDown = () => {
        if (isMobile) {
            return;
        }
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
        setDragging(true);
    };
    const handleMove = useCallback((event) => {
        if (!dragging) {
            return;
        }
        const widthFromRightSide = window.innerWidth - event.clientX;
        const newWidth = Math.min(Math.max(widthFromRightSide, SIDEBAR_MIN_WIDTH), SIDEBAR_MAX_WIDTH);
        cancelAnimationFrame(frameID.current);
        frameID.current = requestAnimationFrame(() => {
            setSidebarWidthVariable(newWidth);
        });
    }, [dragging, setSidebarWidthVariable]);
    const handleMouseUp = () => {
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        setDragging(false);
    };
    useEffect(() => {
        document.addEventListener('mousemove', handleMove);
        document.addEventListener('mouseup', handleMouseUp);
        return () => {
            document.removeEventListener('mousemove', handleMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [handleMove, dragging]);
    return { dragging, onDraggableMouseDown };
};
